import { Spacing } from "manifest-components/src/Containers";

import { NewTransferStatusType } from "manifest-components/src/classes/transferInstruction";
import TransferStatusTile from "../../components/TransferStatusTile";

const TransferStatus = () => {
  return (
    <div style={{ width: "600px", marginLeft: "auto", marginRight: "auto" }}>
      <TransferStatusTile
        status={NewTransferStatusType.WAIT_FOR_IRA_OPENING}
        transferInstructionId="1001"
        sourceAccount="Wait for IRA opening"
        destiantionAccount="Betterment IRA"
        description="Some description"
      />
      <Spacing $space={20} />
      <TransferStatusTile
        status={NewTransferStatusType.PENDING_DESTINATION}
        transferInstructionId="1001"
        sourceAccount="Pending destination"
        destiantionAccount="Betterment IRA"
        description="Some description"
      />
      <Spacing $space={20} />
      <TransferStatusTile
        status={NewTransferStatusType.PENDING_ROTH_DESTINATION}
        transferInstructionId="1001"
        sourceAccount="Pending roth destination"
        destiantionAccount="Betterment IRA"
        description="Some description"
      />
      <Spacing $space={20} />
      <TransferStatusTile
        status={NewTransferStatusType.PENDING_TRAD_DESTINATION}
        transferInstructionId="1001"
        sourceAccount="Pending trad destination"
        destiantionAccount="Betterment IRA"
        description="Some description"
      />
      <Spacing $space={20} />
      <TransferStatusTile
        status={NewTransferStatusType.SCHEDULE_PHONE_CALL}
        transferInstructionId="1001"
        sourceAccount="Schedule phone call"
        destiantionAccount="Betterment IRA"
        description="Some description"
      />
      <Spacing $space={20} />
      <TransferStatusTile
        status={NewTransferStatusType.PROCESSING}
        transferInstructionId="1001"
        sourceAccount="Processing"
        destiantionAccount="Betterment IRA"
        description="Some description"
      />
      <Spacing $space={20} />
      <TransferStatusTile
        status={NewTransferStatusType.ADDITIONAL_INFORMATION_NEEDED}
        transferInstructionId="1001"
        sourceAccount="Additional Information needed"
        destiantionAccount="Betterment IRA"
        description="Some description"
      />
      <Spacing $space={20} />
      <TransferStatusTile
        status={NewTransferStatusType.INITIATED_AT_SOURCE}
        transferInstructionId="1001"
        sourceAccount="Initiated at source"
        destiantionAccount="Betterment IRA"
        description="Some description"
      />
      <Spacing $space={20} />
      <TransferStatusTile
        status={NewTransferStatusType.CANCELLED}
        transferInstructionId="1001"
        sourceAccount="Cancelled"
        destiantionAccount="Betterment IRA"
        description={`Your transfer has been cancelled. For questions, contact{" "}
          <a href="mailto:transfers@usemanifest.com.">transfers@usemanifest.com.</a>`}
      />
      <Spacing $space={20} />
      <TransferStatusTile
        status={NewTransferStatusType.CHECK_SENT_TO_DESTINATION}
        transferInstructionId="1002"
        sourceAccount="Check sent to destination"
        destiantionAccount="Betterment IRA"
        description="Check is sent"
      />
      <Spacing $space={20} />
      <TransferStatusTile
        status={NewTransferStatusType.COMPLETE}
        transferInstructionId="1003"
        sourceAccount="Complete"
        destiantionAccount="Betterment IRA"
        description="Some description"
      />
    </div>
  );
};

export default TransferStatus;
